export type EventCurrency = 'usd' | 'cad';

export const CURRENCY_OPTIONS: { key: EventCurrency; label: string }[] = [
    { key: 'usd', label: 'US Dollar (USD)' },
    { key: 'cad', label: 'Canadian Dollar (CAD)' },
];

export const resolveCurrency = (currency?: string | null): EventCurrency => (currency === 'cad' ? 'cad' : 'usd');

export const currencySymbol = (currency?: string | null) => (resolveCurrency(currency) === 'cad' ? 'CA$' : '$');

export const currencyCode = (currency?: string | null) => resolveCurrency(currency).toUpperCase();
